module.exports = __webpack_public_path__ + "static/media/diener.57031e92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/diener.jpg
// module id = 201
// module chunks = 0